'use client'

import { cn } from '@/core/utils/common'

import { useUiStore } from '@/features/veluvit/stores/ui.store'

import type { CSSProperties } from 'react'

/**
 * 위 막대(모바일 머리줄 · PC 상단 내비)의 유리 바탕 — 막대 안 맨 뒤에 깔린다(막대는 sticky/absolute + z 로 쌓임 맥락).
 * PC 에서는 화면 머리줄(ui.store barHead)까지 늘어나 **유리 한 장**이 된다 — 블러를 두 장 위아래로 붙이면 경계선이 보였다.
 * on — 이 막대의 화면 폭(모바일 머리줄은 'mobile', PC 상단 내비는 'desk').
 */
export default function BarGlass({ on }: { on: 'mobile' | 'desk' }) {
  const extend = useUiStore((s) => (on === 'desk' ? s.barHead : 0))
  return (
    <span
      aria-hidden="true"
      style={{ '--bar-ext': `${extend}px` } as CSSProperties}
      className={cn(
        'pointer-events-none absolute inset-x-0 top-0 -z-10 bg-background/55 backdrop-blur-2xl backdrop-saturate-[1.8]',
        // 모바일 머리줄 유리는 PC 에서 아예 끈다 — PC 는 상단 내비 유리 한 장이 화면 머리줄까지 덮는다
        on === 'mobile'
          ? 'h-[calc(100%+var(--bar-ext))] over10:hidden'
          : 'h-[calc(100%+var(--bar-ext))]'
      )}
    />
  )
}
